import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Prefer Shopify's freshly-rendered section HTML. This is the most reliable way
    // to show the selected variant inventory because the lightweight variant object
    // does not always include inventory_quantity.
    const newInventory = event.detail.data.html?.querySelector('product-inventory');

    if (newInventory) {
      morph(this, newInventory, { childrenOnly: true });
      return;
    }

    // Fallback for themes/events that do not return rendered HTML.
    const variant = event.detail.resource;

    if (!variant) return;

    const textEl = this.querySelector('.product-inventory__text');
    const iconEl = this.querySelector('.product-inventory__icon');
    const managed = variant.inventory_management === 'shopify';
    const qty = Number(variant.inventory_quantity || 0);
    const policy = variant.inventory_policy;

    let status = 'in_stock';
    let message = 'In stock';

    if (managed) {
      if (qty > 0) {
        message = `${qty} in stock`;
        status = 'in_stock';
      } else if (policy === 'continue') {
        message = 'In stock';
        status = 'in_stock';
      } else {
        message = 'Out of stock';
        status = 'out_of_stock';
      }
    } else if (variant.available) {
      message = 'In stock';
      status = 'in_stock';
    } else {
      message = 'Out of stock';
      status = 'out_of_stock';
    }

    if (textEl) textEl.textContent = message;
    if (iconEl) {
      iconEl.classList.remove('product-inventory__icon-low', 'product-inventory__icon-in_stock', 'product-inventory__icon-out_of_stock');
      iconEl.classList.add(`product-inventory__icon-${status}`);
    }
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
